import { createContext, useContext } from 'react';

export const StudioSettingsContext = createContext();

export const useStudioSettings = () => useContext(StudioSettingsContext);
